import toast from 'react-hot-toast';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { Alert, Button } from 'reactstrap';

const showErrorToast = (message) => {
    toast(
        (t) => (
            <Alert
                color="danger"
                className="d-flex align-items-center"
                style={{
                    width: '100%',
                    padding: '0.75rem 1.25rem',
                    margin: 0, // fill the container
                    boxSizing: 'border-box',
                }}>
                <span>{message}</span>
                <Button
                    color="link"
                    className="text-dark ml-auto p-0"
                    onClick={() => toast.dismiss(t.id)}
                    style={{ fontSize: '1.2rem' }}>
                    <FontAwesomeIcon icon={faTimes} />
                </Button>
            </Alert>
        ),
        {
            duration: Infinity, // never auto-close
            style: {
                width: '100%',
                maxWidth: 'none',
                padding: 0,
                background: 'transparent',
                boxShadow: 'none',
            },
        }
    );
};

export default showErrorToast;
